/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import './ShareCardHealthEntrySummary.styles.scss';

import ShareCardIncludedTypeNames from '../../../../constants/ShareCardIncludedTypeNames';
import HealthEntryNameText from '../../../components/HealthEntryNameText';
import HealthEntrySubTitleText from '../../../components/HealthEntrySubTitleText';
import { AttributeState } from '../../../../models/ShareCardTemplateModel';
import { Icons } from '../../../../bphComponents/bundle';
import COLORS from '../../../styles/Colors';
import { useHealthEntryTrackableListForActiveProfile } from '../../../hooks/useTrackable';
import HealthEntryModel from '../../../../models/HealthEntry';
import HealthEntryMetaIcons from '../../../../app/views/components/attributes/HealthEntryMetaIcons';

interface Props {
  healthEntry: any;
  color?: string;
  includedValues: ShareCardIncludedTypeNames;
  shareCardDefinition: any;
  isSelected: boolean;
}
const ShareCardHealthEntrySummary: React.FC<Props> = (props) => {
  const mainStyleClass = classnames('cmp-sharecardhesummary', {
    'is-white': props.color === 'white',
    'is-selected': props.isSelected,
  });
  const isMultiOccurrence = !!props.healthEntry.values;
  const olderHEValuesCount = isMultiOccurrence ? props.healthEntry.values.count() : 0;
  const includeComments = props.shareCardDefinition.comment.health_entry !== AttributeState.excluded;

  const [{ availableTrackableIds }] = useHealthEntryTrackableListForActiveProfile(props.healthEntry.id);

  let hasComments = false;
  let isFlagged = false;

  if (includeComments && props.includedValues) {
    if (props.healthEntry.values) {
      if (props.includedValues === ShareCardIncludedTypeNames.all) {
        hasComments = false;
        isFlagged = props.healthEntry.values.hasAnyFlagged();
      } else if (props.healthEntry.values.hasValues()) {
        hasComments = props.healthEntry.values.mostRecent().comments.hasSharedComments();
        isFlagged = props.healthEntry.values.mostRecent().flag.isFlagged();
      }
    } else {
      hasComments = props.healthEntry.comments.hasSharedComments();
      isFlagged = props.healthEntry.flag.isFlagged();
    }
  }

  const allowsHEValues = HealthEntryModel.allowHEValues(props.healthEntry.data());
  const allowsTrackables = availableTrackableIds.length > 0;

  return (
    <div className={mainStyleClass}>
      <div className="cmp-sharecardhesummary-title" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <HealthEntryNameText healthEntry={props.healthEntry} includedValues={props.includedValues} />
        <div style={{ marginTop: 4 }}>
          <HealthEntryMetaIcons
            hasAttachments={false}
            hasComments={hasComments}
            isFlagged={isFlagged}
          />
        </div>
      </div>
      <div className="cmp-sharecardhesummary-subtitle">
        {
          allowsHEValues &&
          !allowsTrackables &&
          props.includedValues === ShareCardIncludedTypeNames.all
            ? (
              <FormattedMessage id="healthEntry.occurrenceCount.message.text" values={{ digit1: olderHEValuesCount }} />
            ) : (
              <HealthEntrySubTitleText healthEntry={props.healthEntry} />
            )
        }
      </div>
    </div>
  );
};

export default ShareCardHealthEntrySummary;
